

// ユーザーエージェント確認
require('./caracol2/util/check_user_agent.js');
// cssの transform: をjsで書き換える
// var transform_css = require('./caracol2/effect/transform_css.js');

// var $window = $(window);



/********************************
* DOM読み込み完了
*/
$( function(){
    'use strict';


    // ヘッダと、ページトップに戻るボタンのアクション
    var CaracolScrollAmount = require('./caracol2/effect/scroll_amount.js');
    new CaracolScrollAmount( '.js-scroll-amount' );

    // プログレス
    require('./module/progress.js');

    // ページスクロール
    var CaracolPageScroll = require('./caracol2/effect/pagescroll.js');
    new CaracolPageScroll( 'a.js-pagescroll', {time:800, plus:0} );

    // 画像の遅延読み込み
    $('img.js-lazy').lazyload({effect:'fadeIn'});

    // ソーシャルボタン
    require('./caracol2/social/share_button.js').set_share_button( '.js-share-button' );

    // ポップアップ設定
    require('./module/popup.js');

    // メニュー動作
    require( './module/menu.js' );
    require( './module/submenu.js' );

    // タブ
    var CaracolTab = require('./caracol2/navigation/tabs.js');
    new CaracolTab('.js-ccltab_tab');

    // スライダー接待
    require('./module/slider.js');

    // 各ページ用
    require('./page/home.js');
    require('./page/news.js');
    require('./page/onair.js');
    require('./page/episode.js');


    // キャラ用はなかチラつくので module/progress.js で遅延読み込み


});




//////////////////
// WEBPACK FOOTER
// ./js/common.js
// module id = 19
// module chunks = 0